import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pubblica',
  templateUrl: './pubblica.component.html',
  styleUrls: ['./pubblica.component.css']
})
export class PubblicaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
